<div *ngIf="client" class="grid bg-white p-3">
  <!-- HERO: identidad persistente -->
  <div class="col-12">
    <div class="client-hero">
      <div class="hero-main">
        <div class="hero-identity">
          <div class="client-avatar">{{ getClientInitials() }}</div>
          <div class="hero-text">
            <div class="hero-name-row">
              <h1>{{ getClientFullName() }}</h1>
              <span class="entity-pill">{{ client.entity === 'Moral' ? 'PM' : 'PF' }}</span>
              <p-tag
                *ngIf="client.conversionStatus === 'lost'; else accountStatusTag"
                value="Perdido"
                severity="danger"
                icon="pi pi-times-circle"
              ></p-tag>
              <ng-template #accountStatusTag>
                <p-tag
                  [value]="client.status === 'Active' ? 'Activo' : 'Inactivo'"
                  [severity]="getStatusSeverity()"
                  icon="pi pi-circle-fill"
                ></p-tag>
              </ng-template>
              <p-tag
                *ngIf="paymentQuality?.grade"
                [value]="'Pago ' + paymentQuality.grade"
                [severity]="gradeSeverity(paymentQuality.grade)"
                icon="fa-solid fa-star"
                pTooltip="Calificación de comportamiento de pago"
                tooltipPosition="top"
              ></p-tag>
            </div>
            <!-- Atribución en estilo texto (como estaban RFC/email/teléfono): Vendedor,
                             Referido por, Canal. RFC/email/teléfono ya viven en las cards de abajo. -->
            <div class="hero-meta">
              <span *ngIf="client.seller?.names || client.seller?.name"
                ><i class="fa-solid fa-user-tie"></i> Vendedor: {{ client.seller?.names || client.seller?.name }}
                {{ client.seller?.lastNames || '' }}</span
              >
              <span *ngIf="client.referredBy?.names"
                ><i class="fa-solid fa-user-plus"></i> Referido por: {{ client.referredBy?.names }}
                {{ client.referredBy?.lastNames || '' }}</span
              >
              <!-- Canal solo lectura: la edición del canal vive en el form "Editar Cliente"
                                 (campo "Canal de origen"), para no duplicar el medio de edición.
                   B-080: sin `omnichannel.get-all` no hay catálogo que traduzca la clave, y la línea se omite. -->
              <span *ngIf="canListChannels && client?.currentChannelKey" data-test="channel-origin"
                ><i class="fa-solid fa-signal"></i> Llegó por: {{ client.currentChannelKey | channelLabel }}</span
              >
              <!-- F-025 · Enlace al Negocio de HubSpot del que salió o con el que se vinculó el cliente. El aria-label
                   repite el texto visible y avisa que abre otra pestaña; el ícono es decorativo. -->
              <a
                *ngFor="let deal of hubspotDealLinks; trackBy: trackByDealId"
                class="hubspot-deal-link"
                data-test="hubspot-deal-link"
                [href]="deal.url"
                target="_blank"
                rel="noopener noreferrer"
                [attr.aria-label]="deal.label + ' (se abre en una pestaña nueva)'"
                ><i class="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></i> {{ deal.label }}</a
              >
              <span *ngIf="client.broker?.names"
                ><i class="fa-solid fa-user-group"></i> Broker: {{ client.broker?.names }} {{ client.broker?.lastNames || '' }}</span
              >
            </div>
          </div>
        </div>
        <div class="hero-actions">
          <div class="hero-action-group">
            <p-button
              label="Editar"
              icon="fa-solid fa-edit"
              severity="primary"
              (onClick)="editCustomer()"
              [appHasPermission]="['clients', 'update']"
            ></p-button>
            <p-button
              label="Enviar accesos"
              icon="fa-solid fa-paper-plane"
              severity="primary"
              [outlined]="true"
              (onClick)="openSendAccessDialog()"
              [appHasPermission]="['clients', 'update']"
            ></p-button>
            <ng-container *appIfHasPermission="['omnichannel', 'close-client']">
              <!-- "Cierre perdido" solo para prospectos en juego (no `won`/ya-cliente, no `lost`). -->
              <p-button
                *ngIf="isOpenProspect"
                label="Cierre perdido"
                icon="fa-solid fa-flag"
                severity="danger"
                [outlined]="true"
                (onClick)="openCloseModal()"
              ></p-button>
              <p-button
                *ngIf="client?.conversionStatus === 'lost'"
                label="Reactivar"
                icon="fa-solid fa-rotate-left"
                severity="success"
                [outlined]="true"
                (onClick)="reactivateClient()"
              ></p-button>
            </ng-container>
            <!-- Reasignar vendedor/broker (solo Admin). referredBy es inmutable. -->
            <p-button
              *ngIf="isAdmin"
              label="Reasignar"
              icon="fa-solid fa-user-pen"
              severity="secondary"
              [outlined]="true"
              (onClick)="openReassignModal()"
            ></p-button>
            <!-- Gestión de acceso (solo Admin: ['clients','delete']). Botón inteligente:
                             borrar intenta soft-delete; si tiene arrendamientos, ofrece desactivar. -->
            <ng-container *appIfHasPermission="['clients', 'delete']">
              <p-button
                *ngIf="client?.status !== 'Inactive'"
                label="Borrar cliente"
                icon="fa-solid fa-trash"
                severity="danger"
                [outlined]="true"
                (onClick)="confirmDeleteCustomer()"
              ></p-button>
              <p-button
                *ngIf="client?.status === 'Inactive'"
                label="Reactivar acceso"
                icon="fa-solid fa-unlock"
                severity="success"
                [outlined]="true"
                (onClick)="confirmReactivateAccess()"
              ></p-button>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 grid table-wrapper">
    <p-tabView [(activeIndex)]="activeTab">
      <p-tabPanel>
        <ng-template pTemplate="header">
          <i class="fa-solid fa-user"></i>
          <span class="ml-2">General</span>
        </ng-template>
        <div class="client-tab-container">
          <!-- Cards Grid -->
          <div class="cards-grid">
            <!-- Card 1: Información Personal -->
            <div class="info-card">
              <div class="card-header">
                <i class="fa-solid fa-user text-blue-600"></i>
                <h3>Información Personal</h3>
              </div>
              <div class="card-content">
                <div class="compact-grid">
                  <div class="compact-item full-width">
                    <span class="label">Nombre completo</span>
                    <span class="value">{{ getClientFullName() }}</span>
                  </div>
                  <div class="compact-item full-width" *ngIf="client.entity === 'Moral'">
                    <span class="label">Razón social</span>
                    <span class="value">{{ client.legalName }}</span>
                  </div>
                  <div class="compact-item">
                    <span class="label">Tipo de persona</span>
                    <span class="value">{{ client.entity }}</span>
                  </div>
                  <div class="compact-item" *ngIf="client.entity === 'Física'">
                    <span class="label">Nacionalidad</span>
                    <span class="value">{{ client.nationality || 'No especificada' }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Card 2: Información Fiscal -->
            <div class="info-card">
              <div class="card-header">
                <i class="fa-solid fa-file-invoice text-orange-500"></i>
                <h3>Información Fiscal</h3>
              </div>
              <div class="card-content">
                <div class="compact-grid">
                  <div class="compact-item">
                    <span class="label">RFC</span>
                    <span class="value">{{ client.rfc }}</span>
                  </div>
                  <!-- La CIEC es una credencial del SAT: no viaja en el detalle del cliente.
                       B-075: la fila la ve quien puede pedirla (`clients.update`) o verla
                       (`clients.view-ciec`, hoy solo Admin) y dice si hay una guardada y, si no,
                       en qué va la última solicitud. El valor se pide aparte al pulsar «Ver», que
                       deja constancia de quién la consultó, y solo existe si hay CIEC guardada. -->
                  <div class="compact-item ciec-item" *ngIf="canSeeCiecRow" data-test="ciec-row" [attr.data-case]="ciecRowCase">
                    <span class="label">CIEC</span>
                    <ng-container *ngIf="ciecStatus.stored; else ciecMissing">
                      <span class="value value-ciec">
                        <span class="ciec-valor" [class.is-revelada]="ciecRevelada">{{ ciecRevelada || '•••••••••' }}</span>
                        <ng-container *ngIf="canViewCiec">
                          <button
                            type="button"
                            class="ciec-btn"
                            *ngIf="!ciecRevelada"
                            [disabled]="ciecCargando"
                            data-test="ciec-reveal"
                            (click)="revelarCiec()"
                          >
                            <i class="fa-solid" aria-hidden="true" [ngClass]="ciecCargando ? 'fa-spinner fa-spin' : 'fa-eye'"></i>
                            {{ ciecCargando ? 'Abriendo…' : 'Ver' }}
                          </button>
                          <button type="button" class="ciec-btn" *ngIf="ciecRevelada" (click)="ocultarCiec()">
                            <i class="fa-solid fa-eye-slash" aria-hidden="true"></i> Ocultar
                          </button>
                        </ng-container>
                      </span>
                      <span class="ciec-status" [class.is-alert]="ciecRowCase === 'stored-unvalidated'" data-test="ciec-status">
                        <ng-container *ngIf="ciecRowCase === 'stored'"
                          >Guardada el {{ ciecStatus.updatedAt | date: 'dd/MM/yy' }}</ng-container
                        >
                        <ng-container *ngIf="ciecRowCase === 'stored-unvalidated'">{{
                          ciecStatus.credentialStatus === 'invalid' ? 'El SAT la rechazó' : 'Sin validar por el SAT'
                        }}</ng-container>
                      </span>
                      <button
                        type="button"
                        class="ciec-btn ciec-action"
                        *ngIf="ciecRowCase === 'stored-unvalidated' && canUpdateClient"
                        data-test="ciec-request-new"
                        (click)="openCiecRequestDialog()"
                      >
                        <i class="fa-solid fa-envelope" aria-hidden="true"></i> Solicitar nueva CIEC
                      </button>
                      <button
                        type="button"
                        class="ciec-btn ciec-action"
                        *ngIf="showCiecRequestsButton"
                        data-test="ciec-requests"
                        aria-label="Solicitudes de CIEC"
                        (click)="openCiecRequestDialog()"
                      >
                        <i class="fa-solid fa-clock-rotate-left" aria-hidden="true"></i> Solicitudes
                      </button>
                    </ng-container>
                    <ng-template #ciecMissing>
                      <span class="value ciec-missing" data-test="ciec-status" [ngSwitch]="ciecRowCase">
                        <ng-container *ngSwitchCase="'pending'"
                          >Sin CIEC · solicitud enviada el {{ latestCiecRequest?.createdAt | date: 'dd/MM/yy' }} (vence
                          {{ latestCiecRequest?.expiresAt | date: 'dd/MM/yy' }})<ng-container
                            *ngIf="latestCiecRequest?.attemptsUsed as rejections"
                          >
                            · {{ rejections }} {{ rejections === 1 ? 'rechazo' : 'rechazos' }} del SAT</ng-container
                          ></ng-container
                        >
                        <ng-container *ngSwitchCase="'pending-sat'"
                          >Sin CIEC · el cliente la envió el {{ latestCiecRequest?.lastAttempt?.at | date: 'dd/MM/yy' }}; el SAT aún no la
                          confirma</ng-container
                        >
                        <ng-container *ngSwitchCase="'exhausted'"
                          >Sin CIEC · el cliente agotó los intentos el
                          {{ latestCiecRequest?.lastAttempt?.at || latestCiecRequest?.updatedAt | date: 'dd/MM/yy' }}</ng-container
                        >
                        <ng-container *ngSwitchCase="'loading'">Consultando…</ng-container>
                        <ng-container *ngSwitchCase="'failed'"
                          >Sin CIEC · la última solicitud no se completó ({{ latestCiecRequestLabel }})</ng-container
                        >
                        <ng-container *ngSwitchDefault>Sin CIEC registrada</ng-container>
                      </span>
                      <span class="ciec-status is-alert" *ngIf="ciecRequestsState === 'error'" data-test="ciec-requests-error"
                        >No se pudo leer la última solicitud.
                        <button type="button" class="ciec-btn" (click)="loadLatestCiecRequest()">
                          <i class="fa-solid fa-rotate-right" aria-hidden="true"></i> Reintentar
                        </button></span
                      >
                      <button
                        *ngIf="ciecRowCase === 'pending' || ciecRowCase === 'pending-sat'; else requestCiecButton"
                        type="button"
                        class="ciec-btn ciec-action"
                        data-test="ciec-open-request"
                        (click)="openCiecRequestDialog()"
                      >
                        <i class="fa-solid fa-clock-rotate-left" aria-hidden="true"></i> Ver solicitud
                      </button>
                      <ng-template #requestCiecButton>
                        <button
                          *ngIf="canUpdateClient && ciecRowCase !== 'loading'"
                          type="button"
                          class="ciec-btn ciec-action"
                          data-test="ciec-request-new"
                          (click)="openCiecRequestDialog()"
                        >
                          <i class="fa-solid fa-envelope" aria-hidden="true"></i>
                          {{ ciecRowCase === 'exhausted' || ciecRowCase === 'failed' ? 'Solicitar de nuevo' : 'Solicitar CIEC' }}
                        </button>
                      </ng-template>
                    </ng-template>
                  </div>
                  <div class="compact-item" *ngIf="client.entity === 'Física'">
                    <span class="label">CURP</span>
                    <span class="value">{{ client.curp || 'No especificado' }}</span>
                  </div>
                  <div class="compact-item full-width">
                    <span class="label">Régimen fiscal</span>
                    <span class="value">{{ getFiscalRegimeLabel(client.fiscalRegime) }}</span>
                  </div>
                  <div class="compact-item">
                    <span class="label">Sector</span>
                    <span class="value">{{ client.industrySector }}</span>
                  </div>
                  <div class="compact-item">
                    <span class="label">Subsector</span>
                    <span class="value">{{ client.industrySubsector }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Card 3: Información Financiera -->
            <div class="info-card">
              <div class="card-header">
                <i class="fa-solid fa-chart-pie text-green-600"></i>
                <h3>Información Financiera</h3>
              </div>
              <div class="card-content">
                <div class="compact-grid">
                  <div class="compact-item">
                    <span class="label">Ingreso anual</span>
                    <span class="value success">{{ formatCurrency(client.anualIncome) }}</span>
                  </div>
                  <div class="compact-item">
                    <span class="label">Número de empleados</span>
                    <span class="value">{{ client.employees }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!--
                            Las cuentas DESDE las que paga el cliente (F-098 · conciliación bancaria).
                            Gateada con `payments:reconcile` y no con `clients`: expone una CLABE, y
                            `clients:get-by-id` lo tienen roles que no deben verla.
                        -->
            <app-customer-bank-accounts *appIfHasPermission="['payments', 'reconcile']" [client]="client"></app-customer-bank-accounts>

            <!-- Card 3b: Comportamiento de pago (F39) -->
            <div class="info-card">
              <div class="card-header">
                <i class="fa-solid fa-star text-green-600"></i>
                <h3>Comportamiento de pago</h3>
                <div class="header-tags">
                  <p-tag
                    *ngIf="paymentQuality"
                    [value]="paymentQuality.grade ? 'Calificación ' + paymentQuality.grade : 'Sin calificación aún'"
                    [severity]="gradeSeverity(paymentQuality.grade)"
                  ></p-tag>
                </div>
              </div>
              <div class="card-content">
                <!-- Tres estados: cargando · error con reintento · datos -->
                <p-progressSpinner
                  *ngIf="paymentQuality === undefined"
                  styleClass="w-2rem h-2rem"
                  aria-label="Cargando el comportamiento de pago"
                ></p-progressSpinner>
                <p class="text-color-secondary" *ngIf="paymentQualityError">
                  {{ paymentQualityError }}
                  <button
                    pButton
                    type="button"
                    label="Reintentar"
                    icon="pi pi-refresh"
                    class="p-button-text p-button-sm"
                    (click)="loadPaymentQuality()"
                  ></button>
                </p>
                <ng-container *ngIf="paymentQuality as pq">
                  <div class="compact-grid" *ngIf="pq.quality as q">
                    <div class="compact-item">
                      <span class="label">Puntualidad</span><span class="value">{{ q.onTimeRate | percent: '1.0-0' }}</span>
                    </div>
                    <div class="compact-item">
                      <span class="label">Retraso promedio · máximo</span
                      ><span class="value">{{ q.avgDelayDays | number: '1.0-1' }} · {{ q.maxDelayDays }} días</span>
                    </div>
                    <div class="compact-item">
                      <span class="label">Vencidas abiertas</span><span class="value">{{ q.openOverdue }}</span>
                    </div>
                    <div class="compact-item">
                      <span class="label">Tendencia</span
                      ><span class="value">{{ q.trend == null ? '—' : q.trend > 0 ? 'Mejora' : q.trend < 0 ? 'Empeora' : 'Igual' }}</span>
                    </div>
                    <div class="compact-item">
                      <span class="label">Mora cobrada · condonada</span
                      ><span class="value">{{ q.moraPaid | currency }} · {{ q.moraWaived | currency }}</span>
                    </div>
                    <div class="compact-item">
                      <span class="label">Registro tardío (nuestro)</span
                      ><span class="value">{{ q.avgRegistrationLagDays | number: '1.0-1' }} días</span>
                    </div>
                  </div>
                  <p class="text-color-secondary" *ngIf="!pq.quality">
                    Todavía no hay letras cubiertas: sin historial no hay calificación que dar.
                  </p>
                  <table class="cq-leases" *ngIf="pq.leases?.length">
                    <thead>
                      <tr>
                        <th>Arrendamiento</th>
                        <th>Calificación</th>
                        <th>Puntualidad</th>
                        <th>Vencidas</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let l of pq.leases">
                        <td>
                          <!-- B-080: sin `leases.view` la ruta del arrendamiento rebota; el folio va como texto. -->
                          <a
                            *ngIf="canOpenLease; else leaseFolioText"
                            [routerLink]="['/lease', l.leaseId]"
                            [queryParams]="{ tab: 'exigibilidad' }"
                            data-test="lease-folio-link"
                            >{{ l.folio }}</a
                          >
                          <ng-template #leaseFolioText
                            ><span data-test="lease-folio-text">{{ l.folio }}</span></ng-template
                          >
                        </td>
                        <td><p-tag [value]="l.grade || '—'" [severity]="gradeSeverity(l.grade)"></p-tag></td>
                        <td>{{ l.quality?.onTimeRate | percent: '1.0-0' }}</td>
                        <td>{{ l.quality?.openOverdue }}</td>
                      </tr>
                    </tbody>
                  </table>
                </ng-container>
              </div>
            </div>

            <!-- Card 4: Contacto Principal -->
            <div class="info-card">
              <div class="card-header">
                <i class="fa-solid fa-phone text-purple-500"></i>
                <h3>Contacto Principal</h3>
              </div>
              <div class="card-content">
                <div class="compact-grid">
                  <!-- F-157 · El celular y el correo principales son UNO solo: con ellos entra el
                       cliente y a ellos le llegan los avisos. Los demás van en «otros». -->
                  <div class="compact-item">
                    <span class="label">Celular (inicia sesión)</span>
                    <span class="value">{{ client.phone }}</span>
                  </div>
                  <div class="compact-item">
                    <span class="label">Correo (inicia sesión)</span>
                    <span class="value">{{ client.email }}</span>
                  </div>
                  <div class="compact-item" *ngIf="client.otherPhones?.length">
                    <span class="label">Otros teléfonos</span>
                    <span class="value">{{ client.otherPhones.join(', ') }}</span>
                  </div>
                  <div class="compact-item" *ngIf="client.otherEmails?.length">
                    <span class="label">Otros correos</span>
                    <span class="value">{{ client.otherEmails.join(', ') }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Card 5: Domicilio Operativo -->
            <div class="info-card">
              <div class="card-header">
                <i class="fa-solid fa-location-dot text-red-500"></i>
                <h3>Domicilio Operativo</h3>
              </div>
              <div class="card-content">
                <div class="compact-grid">
                  <div class="compact-item full-width">
                    <span class="label">Calle</span>
                    <span class="value">{{ client?.address?.street }}</span>
                  </div>
                  <div class="compact-item">
                    <span class="label">No. Exterior</span>
                    <span class="value">{{ client?.address?.exteriorNumber || 'S/N' }}</span>
                  </div>
                  <div class="compact-item">
                    <span class="label">No. Interior</span>
                    <span class="value">{{ client?.address?.interiorNumber || 'N/A' }}</span>
                  </div>
                  <div class="compact-item">
                    <span class="label">Colonia</span>
                    <span class="value">{{ client?.address?.colony }}</span>
                  </div>
                  <div class="compact-item">
                    <span class="label">Ciudad</span>
                    <span class="value">{{ client?.address?.city }}</span>
                  </div>
                  <div class="compact-item">
                    <span class="label">Municipio</span>
                    <span class="value">{{ client?.address?.municipality }}</span>
                  </div>
                  <div class="compact-item">
                    <span class="label">Estado</span>
                    <span class="value">{{ client?.address?.state }}</span>
                  </div>
                  <div class="compact-item">
                    <span class="label">Código Postal</span>
                    <span class="value">{{ client?.address?.postalCode }}</span>
                  </div>
                  <div class="compact-item">
                    <span class="label">País</span>
                    <span class="value">{{ client?.address?.country }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Card 6: Domicilio Fiscal -->
            <div class="info-card">
              <div class="card-header">
                <i class="fa-solid fa-building-columns text-teal-500"></i>
                <h3>Domicilio Fiscal</h3>
              </div>
              <div class="card-content">
                <div class="same-address-message" *ngIf="client.sameLegalAddress !== false">
                  <i class="fa-solid fa-circle-check"></i>
                  <span>Mismo que domicilio operativo</span>
                </div>
                <div class="compact-grid" *ngIf="client.sameLegalAddress === false">
                  <div class="compact-item full-width">
                    <span class="label">Calle</span>
                    <span class="value">{{ client.legalAddress?.street }}</span>
                  </div>
                  <div class="compact-item">
                    <span class="label">No. Exterior</span>
                    <span class="value">{{ client.legalAddress?.exteriorNumber || 'S/N' }}</span>
                  </div>
                  <div class="compact-item">
                    <span class="label">No. Interior</span>
                    <span class="value">{{ client.legalAddress?.interiorNumber || 'N/A' }}</span>
                  </div>
                  <div class="compact-item">
                    <span class="label">Colonia</span>
                    <span class="value">{{ client.legalAddress?.colony }}</span>
                  </div>
                  <div class="compact-item">
                    <span class="label">Ciudad</span>
                    <span class="value">{{ client.legalAddress?.city }}</span>
                  </div>
                  <div class="compact-item">
                    <span class="label">Municipio</span>
                    <span class="value">{{ client.legalAddress?.municipality }}</span>
                  </div>
                  <div class="compact-item">
                    <span class="label">Estado</span>
                    <span class="value">{{ client.legalAddress?.state }}</span>
                  </div>
                  <div class="compact-item">
                    <span class="label">Código Postal</span>
                    <span class="value">{{ client.legalAddress?.postalCode }}</span>
                  </div>
                  <div class="compact-item">
                    <span class="label">País</span>
                    <span class="value">{{ client.legalAddress?.country }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Plan v4.3 §9.3 · Preofertas del cliente, una por arrendamiento (solo con el módulo y si hay) -->
            <app-client-preoffers class="wide-card" [clientId]="id"></app-client-preoffers>

            <!-- Plan v4.3 §9.5 · Obligados solidarios (full-width): se guardan aparte del formulario del cliente -->
            <div class="info-card wide-card">
              <div class="card-header">
                <i class="fa-solid fa-handshake text-indigo-500"></i>
                <h3>Obligados solidarios</h3>
                <span class="contact-count" *ngIf="guarantors.length > 0">
                  {{ guarantors.length }} obligado{{ guarantors.length !== 1 ? 's' : '' }}
                </span>
                <!-- Tooltips estáticos a propósito: los specs de la ficha montan la plantilla sin PrimeNG. -->
                <ng-container *ngIf="canUpdateClient">
                  <button
                    *ngIf="guarantors.length < maxGuarantors; else guarantorsFull"
                    pButton
                    type="button"
                    label="Agregar"
                    icon="pi pi-plus"
                    data-test="guarantor-add"
                    class="p-button-text p-button-sm"
                    (click)="openGuarantorDialog(null)"
                  ></button>
                  <ng-template #guarantorsFull>
                    <span pTooltip="El cliente ya tiene el máximo de obligados solidarios">
                      <button pButton type="button" label="Agregar" icon="pi pi-plus" class="p-button-text p-button-sm" disabled></button>
                    </span>
                  </ng-template>
                </ng-container>
              </div>
              <div class="card-content">
                <p class="guarantor-legend">
                  <i class="fa-solid fa-calculator"></i>
                  Cuentan para el colateral de la calculadora de riesgo.
                </p>
                <div class="contacts-empty" *ngIf="guarantors.length === 0">
                  <i class="fa-solid fa-user-slash"></i>
                  <span>El cliente no tiene obligados solidarios registrados</span>
                </div>
                <div class="contact-sub-card" *ngFor="let guarantor of guarantors" data-test="guarantor-card">
                  <div class="section-header-mini guarantor-header">
                    <i class="fa-solid" [ngClass]="guarantor.personType === 'PM' ? 'fa-building' : 'fa-user'"></i>
                    <span>{{ guarantorName(guarantor) }}</span>
                    <p-tag value="Obligado solidario" severity="info"></p-tag>
                    <div class="guarantor-actions" *ngIf="canUpdateClient">
                      <button
                        pButton
                        type="button"
                        icon="pi pi-pencil"
                        class="p-button-text p-button-sm p-button-rounded"
                        [attr.aria-label]="'Editar a ' + guarantorName(guarantor)"
                        pTooltip="Editar"
                        (click)="openGuarantorDialog(guarantor)"
                      ></button>
                      <button
                        *ngIf="guarantors.length > 1; else lastGuarantor"
                        pButton
                        type="button"
                        icon="pi pi-trash"
                        class="p-button-text p-button-sm p-button-rounded p-button-danger"
                        [attr.aria-label]="'Quitar a ' + guarantorName(guarantor)"
                        pTooltip="Quitar"
                        [disabled]="removingGuarantorId !== null"
                        (click)="confirmRemoveGuarantor(guarantor)"
                      ></button>
                      <ng-template #lastGuarantor>
                        <span pTooltip="Debe quedar al menos un obligado solidario">
                          <button
                            pButton
                            type="button"
                            icon="pi pi-trash"
                            class="p-button-text p-button-sm p-button-rounded p-button-danger"
                            [attr.aria-label]="
                              'No se puede quitar a ' + guarantorName(guarantor) + ': debe quedar al menos un obligado solidario'
                            "
                            disabled
                          ></button>
                        </span>
                      </ng-template>
                    </div>
                  </div>
                  <div class="compact-grid">
                    <div class="compact-item">
                      <span class="label">Tipo</span>
                      <span class="value">{{ guarantor.personType === 'PM' ? 'Persona moral' : 'Persona física' }}</span>
                    </div>
                    <div class="compact-item">
                      <span class="label">Relación</span>
                      <span class="value">{{ guarantorRelationship(guarantor.relationship) }}</span>
                    </div>
                    <div class="compact-item" *ngIf="guarantor.rfc">
                      <span class="label">RFC</span>
                      <span class="value">{{ guarantor.rfc }}</span>
                    </div>
                    <div class="compact-item" *ngIf="guarantor.curp">
                      <span class="label">CURP</span>
                      <span class="value">{{ guarantor.curp }}</span>
                    </div>
                    <div class="compact-item">
                      <span class="label">Celular</span>
                      <span class="value">{{ guarantor.phone || 'N/A' }}</span>
                    </div>
                    <div class="compact-item">
                      <span class="label">Email</span>
                      <span class="value">{{ guarantor.email || 'N/A' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Card 7: Contactos Adicionales (full-width) -->
            <div class="info-card wide-card">
              <div class="card-header">
                <i class="fa-solid fa-users text-indigo-500"></i>
                <h3>Contactos Adicionales</h3>
                <span class="contact-count" *ngIf="otherContacts.length > 0">
                  {{ otherContacts.length }} contacto{{ otherContacts.length !== 1 ? 's' : '' }}
                </span>
              </div>
              <div class="card-content">
                <div class="contacts-empty" *ngIf="otherContacts.length === 0">
                  <i class="fa-solid fa-user-slash"></i>
                  <span>No hay contactos adicionales registrados</span>
                </div>
                <div class="contact-sub-card" *ngFor="let contact of otherContacts" data-test="contact-card">
                  <div class="section-header-mini">
                    <i class="fa-solid fa-user-tie"></i>
                    <span>{{ contact.contactType }} — {{ contact.firstName }} {{ contact.lastName }} {{ contact.middleName }}</span>
                  </div>
                  <div class="compact-grid">
                    <div class="compact-item">
                      <span class="label">Teléfono</span>
                      <span class="value">{{ contact.phone || contact.telefono || 'N/A' }}</span>
                    </div>
                    <div class="compact-item">
                      <span class="label">Email</span>
                      <span class="value">{{ contact.email || 'N/A' }}</span>
                    </div>
                    <div class="compact-item" *ngIf="contact.rfc">
                      <span class="label">RFC</span>
                      <span class="value">{{ contact.rfc }}</span>
                    </div>
                    <div class="compact-item" *ngIf="contact.curp">
                      <span class="label">CURP</span>
                      <span class="value">{{ contact.curp }}</span>
                    </div>
                    <div class="compact-item">
                      <span class="label">Puesto</span>
                      <span class="value">{{ contact.position || contact.puesto || 'N/A' }}</span>
                    </div>
                    <div class="compact-item">
                      <span class="label">Participación</span>
                      <span class="value">{{ contact.participationPercentage || 0 }}%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel>

      <p-tabPanel>
        <ng-template pTemplate="header">
          <i class="fa-solid fa-folder-open"></i>
          <span class="ml-2">Documentos</span>
        </ng-template>
        <ng-template pTemplate="content">
          <app-customer-documents-tabs [client]="client" (changed)="getCustomerData()"></app-customer-documents-tabs>
        </ng-template>
      </p-tabPanel>

      <p-tabPanel *appIfHasPermission="['assets', 'get-all']" data-test="assets-tab">
        <ng-template pTemplate="header">
          <i class="fa-solid fa-file-invoice-dollar"></i>
          <span class="ml-2">Activos</span>
        </ng-template>

        <ng-template pTemplate="content">
          <p class="mb-3 text-color-secondary">Listado de activos registrados para este cliente</p>
          <app-main-table [apiService]="assetsService" [columns]="assetsColumns" [pluralEntityName]="'activos'"></app-main-table>
        </ng-template>
      </p-tabPanel>

      <p-tabPanel *appIfHasPermission="['quotations', 'get-all']" data-test="quotes-tab">
        <ng-template pTemplate="header">
          <i class="fa-solid fa-calculator"></i>
          <span class="ml-2">Cotizaciones</span>
        </ng-template>

        <ng-template pTemplate="content">
          <p class="mb-3 text-color-secondary">Listado de cotizaciones registradas para este cliente</p>
          <app-main-table [apiService]="quotesService" [columns]="quotesColumns" [pluralEntityName]="'cotizaciones'"></app-main-table>
        </ng-template>
      </p-tabPanel>

      <p-tabPanel *appIfHasPermission="['leases', 'get-all']" data-test="leases-tab">
        <ng-template pTemplate="header">
          <i class="fa-solid fa-layer-group"></i>
          <span class="ml-2">Arrendamientos</span>
        </ng-template>

        <ng-template pTemplate="content">
          <p class="mb-3 text-color-secondary">Listado de arrendamientos registrados para este cliente</p>
          <app-main-table [apiService]="leaseService" [columns]="leasesColumns" [pluralEntityName]="'arrendamientos'"></app-main-table>
        </ng-template>
      </p-tabPanel>

      <p-tabPanel *appIfHasPermission="['payments', 'get-all']">
        <ng-template pTemplate="header">
          <i class="fa-solid fa-file-invoice-dollar"></i>
          <span class="ml-2">Pagos</span>
        </ng-template>

        <ng-template pTemplate="content">
          <p class="mb-3 text-color-secondary">Listado de pagos registrados para este cliente</p>
          <app-main-table [apiService]="paymentsService" [columns]="paymentsColumns" [pluralEntityName]="'pagos'"></app-main-table>
        </ng-template>
      </p-tabPanel>

      <!-- ADR-0031: Análisis Fiscal CIEC (vista vigente del cliente).
                 Carga el GET en el constructor (no en (onClick), que en PrimeNG 16
                 NO existe como output de p-tabPanel). Así al recargar la página y
                 abrir este tab, los datos ya están hidratados.
           F-158: solo con `leases.view`; Contabilidad ya no la ve. -->
      <p-tabPanel #ciecTab *ngIf="canViewCiecAnalysis" data-test="ciec-analysis-tab">
        <ng-template pTemplate="header">
          <i class="fa-solid fa-shield-halved"></i>
          <span class="ml-2">Análisis Fiscal CIEC</span>
        </ng-template>

        <ng-template pTemplate="content">
          <!-- ADR-0032 · `(requestCiec)` abre el modal para mandar magic link al cliente.
                         El botón solo aparece cuando NO hay verificación vigente (lo controla
                         el getter `canRequestCiec` del propio componente shared). -->
          <app-ciec-analysis-view
            [verification]="clientVerification"
            mode="client"
            [canRefresh]="!isCiecExtractionPending"
            [refreshDisabledReason]="ciecRefreshDisabledReason"
            [refreshing]="isCiecRefreshing"
            (refresh)="runClientCiecRefresh()"
            [ekatenaReport]="ekatenaReport"
            [ekatenaBuscando]="ekatenaBuscando"
            [ekatenaImportando]="ekatenaImportando"
            (importEkatena)="importarEkatena()"
            (requestCiec)="openCiecRequestDialog()"
            (enterCiec)="openCiecEntryDialog()"
            [snapshotContext]="snapshotContext"
            [initialSubtab]="ciecSubtab"
          >
          </app-ciec-analysis-view>
        </ng-template>
      </p-tabPanel>

      <!-- Plan v4.2 §9.1 · El formato con el que el cliente autoriza consultar su historial y su validación por Legal. -->
      <p-tabPanel *ngIf="canViewCreditHistory" data-test="credit-history-tab">
        <ng-template pTemplate="header">
          <i class="fa-solid fa-file-signature"></i>
          <span class="ml-2">Buró y Círculo</span>
        </ng-template>
        <ng-template pTemplate="content">
          <app-customer-credit-history [client]="client" (changed)="getCustomerData()"></app-customer-credit-history>
        </ng-template>
      </p-tabPanel>

      <p-tabPanel *ngIf="canViewTimeline">
        <ng-template pTemplate="header">
          <i class="pi pi-clock"></i>
          <span class="ml-2">Historial</span>
        </ng-template>
        <app-omnichannel-timeline [clientId]="id"></app-omnichannel-timeline>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>

<!-- Dialog para edición de cliente -->
<p-dialog
  [(visible)]="showCustomerEditDialog"
  [style]="{ width: '90vw', maxWidth: '1200px' }"
  header="Editar Cliente"
  [modal]="true"
  [dismissableMask]="true"
  styleClass="p-fluid customer-edit-dialog"
>
  <ng-template pTemplate="content">
    <app-customer-new></app-customer-new>
  </ng-template>

  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-outlined" (click)="hideCustomerEditDialog()"></button>
    <button pButton pRipple label="Guardar" icon="pi pi-check" (click)="saveCustomer()" [disabled]="!customerService.entity.valid"></button>
  </ng-template>
</p-dialog>

<!-- ADR-0032 · Modal de solicitud de CIEC al cliente por magic link -->
<app-ciec-request-dialog
  [(visible)]="showCiecRequestDialog"
  [clientId]="id"
  [clientEmail]="client?.email || ''"
  [clientName]="getClientFullName()"
  [ciecStatus]="client?.ciecStatus ?? null"
  (changed)="onCiecRequestChanged()"
  (editClient)="onCiecRequestEditClient()"
>
</app-ciec-request-dialog>

<!-- ADR-0032 · Modal "Ingresar CIEC" — el interno captura la CIEC a mano y corre el análisis -->
<p-dialog
  [(visible)]="showCiecEntryDialog"
  [style]="{ width: '460px' }"
  header="Ingresar CIEC"
  [modal]="true"
  [dismissableMask]="true"
  styleClass="ciec-entry-dialog"
>
  <ng-template pTemplate="content">
    <p class="ciec-entry-hint">
      Ingresa la Contraseña CIEC del cliente para correr el análisis fiscal con el RFC registrado. Se guarda cifrada solo si el SAT la
      valida, para futuras revalidaciones.
    </p>

    <div class="ciec-entry-field">
      <label>RFC registrado</label>
      <div class="ciec-entry-rfc">{{ client?.rfc || '—' }}</div>
    </div>

    <div class="ciec-entry-field">
      <label for="ciecEntryValue">Contraseña CIEC <span class="ciec-entry-req">*</span></label>
      <input
        id="ciecEntryValue"
        pInputText
        type="password"
        autocomplete="off"
        placeholder="••••••••"
        [(ngModel)]="ciecEntryValue"
        (keyup.enter)="submitCiecEntry()"
      />
      <small>Mínimo {{ ciecMinLength }} caracteres. Es la contraseña de la CIEC del SAT, no la de la e.firma.</small>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-outlined" (click)="showCiecEntryDialog = false"></button>
    <button
      pButton
      pRipple
      label="Verificar CIEC"
      icon="fa-solid fa-key"
      class="p-button-success"
      (click)="submitCiecEntry()"
      [disabled]="!isCiecEntryValid"
    ></button>
  </ng-template>
</p-dialog>

<!-- Omnicanal · reasignar canal / cerrar cliente. B-080: el modal pide el catálogo de canales al iniciar,
     así que solo existe para quien puede reasignar. -->
<app-assign-channel-modal
  *appIfHasPermission="['omnichannel', 'assign-channel']"
  [(visible)]="assignModalVisible"
  [clientId]="id"
  [currentChannelKey]="client?.currentChannelKey"
  (assigned)="getCustomerData()"
>
</app-assign-channel-modal>

<!-- Enviar accesos al cliente (backoffice): resetea contraseña + manda correo REGISTER -->
<p-dialog
  [(visible)]="showSendAccessDialog"
  [style]="{ width: '460px' }"
  header="Enviar accesos al cliente"
  [modal]="true"
  [dismissableMask]="!isSendingAccess"
  styleClass="send-access-dialog"
  (onHide)="accessResult = null"
>
  <ng-template pTemplate="content">
    <!-- Paso 1: aviso previo -->
    <ng-container *ngIf="!accessResult">
      <p class="send-access-hint">
        Se generará una <strong>contraseña temporal</strong> para <strong>{{ getClientFullName() }}</strong> y se enviará a
        <strong>{{ client?.email || '—' }}</strong> junto con el link al canal digital.
      </p>
      <div class="send-access-warn">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span>Esto <strong>reemplaza</strong> la contraseña actual del cliente. Al ingresar se le pedirá cambiarla.</span>
      </div>
    </ng-container>

    <!-- Paso 2: resultado con las credenciales -->
    <ng-container *ngIf="accessResult">
      <div class="send-access-status" [class.ok]="accessResult.emailSent" [class.warn]="!accessResult.emailSent">
        <i class="fa-solid" [ngClass]="accessResult.emailSent ? 'fa-circle-check' : 'fa-triangle-exclamation'"></i>
        <span *ngIf="accessResult.emailSent">Correo enviado a {{ client?.email }}.</span>
        <span *ngIf="!accessResult.emailSent">No se pudo enviar el correo. Comparte estos accesos con el cliente manualmente.</span>
      </div>
      <div class="send-access-cred">
        <label>Usuario</label>
        <div class="send-access-value">{{ accessResult.loginUsername }}</div>
      </div>
      <div class="send-access-cred">
        <label>Contraseña temporal</label>
        <div class="send-access-value send-access-copyrow">
          <span>{{ accessResult.tempPassword }}</span>
          <button
            pButton
            pRipple
            type="button"
            icon="fa-solid fa-copy"
            class="p-button-text p-button-sm"
            aria-label="Copiar contraseña"
            (click)="copyAccessPassword()"
          ></button>
        </div>
      </div>
      <small class="send-access-note">El cliente deberá cambiar la contraseña en su primer ingreso.</small>
    </ng-container>
  </ng-template>

  <ng-template pTemplate="footer">
    <ng-container *ngIf="!accessResult">
      <button
        pButton
        pRipple
        label="Cancelar"
        icon="pi pi-times"
        class="p-button-outlined"
        (click)="showSendAccessDialog = false"
        [disabled]="isSendingAccess"
      ></button>
      <button
        pButton
        pRipple
        label="Enviar accesos"
        icon="fa-solid fa-paper-plane"
        class="p-button-success"
        (click)="submitSendAccess()"
        [loading]="isSendingAccess"
        [disabled]="isSendingAccess"
      ></button>
    </ng-container>
    <ng-container *ngIf="accessResult">
      <button pButton pRipple label="Listo" icon="pi pi-check" (click)="showSendAccessDialog = false"></button>
    </ng-container>
  </ng-template>
</p-dialog>

<app-close-client-modal
  [(visible)]="closeModalVisible"
  [clientId]="id"
  [conversionStatus]="client?.conversionStatus"
  (closed)="getCustomerData()"
>
</app-close-client-modal>

<p-toast position="top-right"></p-toast>

<!-- Toast messages -->
<p-toast></p-toast>

<!-- Confirmación de acciones destructivas de gestión de acceso (borrar / desactivar / reactivar). -->
<p-confirmDialog
  [style]="{ width: '460px' }"
  acceptButtonStyleClass="p-button-sm"
  rejectButtonStyleClass="p-button-sm p-button-text"
></p-confirmDialog>

<!-- Reasignar vendedor/broker (solo Admin) -->
<app-reassign-owner-modal [(visible)]="showReassignModal" [clientId]="id" [client]="client" (reassigned)="getCustomerData()">
</app-reassign-owner-modal>

<!-- Plan v4.3 §9.5 · Alta y edición de un obligado solidario -->
<app-guarantor-contact-dialog
  [(visible)]="showGuarantorDialog"
  [clientId]="id"
  [holderRfc]="client?.rfc ?? null"
  [guarantors]="guarantors"
  [editing]="editingGuarantor"
  (saved)="onGuarantorSaved()"
></app-guarantor-contact-dialog>
